import React, { useState } from 'react'
import styled from 'styled-components'
import { IoIosArrowDown } from 'react-icons/io'
import { ArrowAccordion } from 'src/assets'
interface IProps {
  isShow?: any
  question?: any
  answer?: any
  show?: boolean
}
const Wrapper = styled.div<IProps>`
  width: 100%;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: 500;
  .mb {
    display: none;
  }
  .toggle {
    display: none;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      transform: ${(props) => (props.isShow ? 'rotate(90deg)' : null)};
      transition: all 0.3s;
      display: block;
    }
  }

  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    .mb {
      display: flex;
    }

    .lg {
      display: none;
    }
  }
  .question {
    border: 1px solid ${({ theme }) => theme.colors.Faqwhite};
    border-radius: 10px;
    width: 95%;
    margin-top: 20px;
    height: 100px;
    background-color: ${({ theme }) => theme.colors.moneyInterestCard};
    display: flex;
    align-items: center;
    padding: 0px 30px;
    cursor: pointer;
    justify-content: space-between;
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      width: 95%;
      height: auto;
      padding: 10px 10px;
    }
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      justify-content: initial;
    }

    .que {
      font-size: ${({ theme }) => theme.fontSize.x1};
      color: ${({ theme }) => theme.colors.navyBlue};
      @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
        font-size: ${({ theme }) => theme.fontSize.s};
        padding-left: 10px;
      }
    }
    .arrow {
      transform: ${(props) => (props.isShow ? 'rotate(180deg)' : null)};
      transition: all 0.3s;
      width: 33.33px;
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        display: none;
      }
    }
  }
  .answer {
    border-radius: 0px 0px 10px 10px;
    width: 95%;
    padding: 0px 30px 24px 30px;
    margin-top: -30px;
    background-color: ${({ theme }) => theme.colors.moneyInterestCard};
    display: ${(props) => (props.isShow ? 'block' : 'none')};
    @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
      width: 90%;
      padding: 15px 20px;
    }
    .ans {
      font-size: ${({ theme }) => theme.fontSize.x1};
      color: ${({ theme }) => theme.colors.resetColor};
      @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
        font-size: ${({ theme }) => theme.fontSize.x4};
      }
      @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
        padding-left: 25px;
      }
    }
  }
`

const Accordion = ({ question, answer }: IProps) => {
  const [show, setShow] = useState(false)

  const toggleAccordionHandler = () => {
    setShow(!show)
  }
  return (
    <Wrapper isShow={show}>
      <div onClick={toggleAccordionHandler} className="question">
        <img src={ArrowAccordion} alt="" className="toggle" />
        <p className="que">{question}</p>
        <IoIosArrowDown className="arrow" />
      </div>
      <div className="answer">
        <p className="ans">{answer}</p>
      </div>
    </Wrapper>
  )
}
export default Accordion
